import React from 'react';
import { useHistory } from 'react-router-dom';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import Content from '../WizardTemplates/WizardStepTemplate/Content';
import ScheduledCashJournalOverride from './metaOverrideSet';

export default function ScheduledCashJournal({ className, resource }) {
  const history = useHistory();
  const { loadPageContentLink } = usePageContentContext();

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      history.push('/');
    }
  };

  const hasRedirect = hasRelationship(resource, fr.relationships.redirect.name);
  const hasNext = resource.meta().canPost();

  const onNext = async () => {
    await loadPageContentLink(resource.relationship(fr.relationships.redirect.name).link('related'));
  };

  return <>
    <WizardStepWrapperTemplate
      className={className}
      layout={Content}
      metaOverrideSet={ScheduledCashJournalOverride}
      LayoutProps={{ resource }}
      resource={resource}
      onNext={(!hasNext && hasRedirect) ? onNext : undefined}
      onClose={onClose}
    />
  </>;
}
